import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
/**
 * This is a const to map the routes to their sessionStorage keys
 */
export const pathStorageConfig = [
	{ basePath: "/administration/companies", storageKey: "companyFilters" },
	{ basePath: "/administration/users", storageKey: "userFilters" },
	{ basePath: "/administration/organizations", storageKey: "organizationFilters" },
];

/**
 * Hook that handles clearing UI filter state from sessionStorage
 * when navigating between different pages or during page reloads.
 *
 * This hook performs two main functions:
 * 1. Tracks navigation between routes and clears irrelevant filter data
 * 2. Listens for page reload events and clears all filter data
 *
 * @returns {void}
 */
function useResetFiltersOnNavigation() {
	const location = useLocation();
	const previousPathRef = useRef(location.pathname);

	// Handle both initial load and route changes
	useEffect(() => {
		const currentPath = location.pathname;
		const previousPath = previousPathRef.current;

		// Clean filters that aren't relevant to current path
		const keysToPreserve = pathStorageConfig
			.filter((config) => currentPath.includes(config.basePath))
			.map((config) => config.storageKey);

		pathStorageConfig.forEach(({ storageKey }) => {
			if (!keysToPreserve.includes(storageKey)) {
				sessionStorage.removeItem(storageKey);
			}
		});

		previousPathRef.current = currentPath;
	}, [location.pathname]);

	// Handle full page reload (unchanged)
	useEffect(() => {
		const handleBeforeUnload = () => {
			pathStorageConfig.forEach((config) => {
				sessionStorage.removeItem(config.storageKey);
			});
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);
}
export default useResetFiltersOnNavigation;
